import React, { useContext, useEffect, useRef, useState } from "react";
import badge from "../../img/badge.png";
import { Col, Row, Modal, Button } from "react-bootstrap";
import { isEmpty, isNumber } from "lodash";
import BetSlipContext from "../../context/BetSlipContext";
import useScroll from "../../component/Scroll";
import { useNavigate } from "react-router-dom";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { FaArrowRight, FaMinus, FaPlus } from "react-icons/fa";
import BookPosition from "./BookPosition";
import RenderSlip from "./RenderSlip";
import AuthContext from "../../context/AuthContext";
const Fancy = ({
  title,
  data,
  user,
  detail,
  profileData,
  setLimit,
  scrollHeight,
  position,
  setRightTab,
  BetSlip,
  active,
  setActive,
}) => {
  const { setLoginModal } = useContext(AuthContext);
  const [showPosition, setShowPosition] = useState({
    status: false,
    object: {},
  });
  const { t } = useTranslation();
  const {
    setShowBetDialog,
    setBetSlipObject,
    betSlipObject,
    showBetDialog,
    handelPlaceFancy,
  } = useContext(BetSlipContext);
  const naviagte = useNavigate();
  const myRef = useRef(null);
  const [scrollId, setScrollId] = useScroll(myRef);
  const [localLimit, setLocalLimit] = useState({});
  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) =>
        res?.type == "fancy" &&
        (profileData?.arrayCheck == "details"
          ? true
          : res?.sportType == detail?.gameType)
    );

    let findNewLimit = detail?.limit?.find((res) => {
      return res?.type == "fancy";
    });
    if (!isEmpty(findNewLimit)) {
      setLocalLimit({
        ...obj,
        maxAmount:
          Number(obj?.maxAmount) > Number(findNewLimit?.maxAmount)
            ? Number(findNewLimit?.maxAmount)
            : Number(obj?.maxAmount),
        oddsLimit:
          Number(obj?.oddsLimit) > Number(findNewLimit?.oddsLimit)
            ? Number(findNewLimit?.oddsLimit)
            : Number(obj?.oddsLimit),
      });
    } else {
      if (!isEmpty(obj)) {
        setLocalLimit(obj);
      } else {
        setLocalLimit({
          maxAmount: 1000,
          maxProfit: 10000,
          minAmount: 1,
          oddsLimit: 10,
        });
      }
    }
  }, [detail]);

  const handelChange = (odds, type, team, item, index) => {
    if (!isEmpty(user)) {
      if (odds?.rt > 0) {
        if (!profileData?.profile?.isOneClickBetStake) {
          setScrollId(index);
          setShowBetDialog(true);
        }
        let object = {
          odds: odds?.rt,
          teamName: team,
          betType: type,
          playType: "fancy",
          object: {
            ...item,
            ...odds,
            teamName: team,
            eventId: detail?.eventId,
            marketId: detail?.marketId,
          },
        };
        if (profileData?.profile?.isOneClickBetStake) {
          handelPlaceFancy(localLimit, {
            ...object,
            bidPrice: profileData?.profile?.defaultOneClickBetStake,
          });
        }
        setLimit(localLimit);
        setBetSlipObject((prev) => ({
          ...prev,
          ...object,
        }));
      }
    } else {
      setLoginModal(true);
    }
  };

  const mergeAndCalculate = (betSlipObject, apiData) => {
    const betRun = betSlipObject.odds;
    let profitAmount;
    let loseAmount;

    if (betSlipObject.betType === "Yes") {
      profitAmount = parseFloat(
        ((betSlipObject.bidPrice * betSlipObject.object.pt) / 100).toFixed(2)
      );
      loseAmount = -parseFloat(betSlipObject.bidPrice);
    } else if (betSlipObject.betType === "No") {
      profitAmount = parseFloat(betSlipObject.bidPrice);
      loseAmount = -parseFloat(
        ((betSlipObject.bidPrice * betSlipObject.object.pt) / 100).toFixed(2)
      );
    }

    let mergedBetRunPosition = apiData.betRunPosition.map((position) => ({
      ...position,
      position:
        position.position !== null && position.position !== undefined
          ? position.position
          : 0,
    }));

    const minBetRun = Math.min(
      ...mergedBetRunPosition.map((item) => item.betRun)
    );
    const maxBetRun = Math.max(
      ...mergedBetRunPosition.map((item) => item.betRun)
    );

    if (betRun > maxBetRun) {
      for (let i = maxBetRun + 1; i <= betRun; i++) {
        mergedBetRunPosition.push({ betRun: i, position: 0 });
      }
    } else if (betRun < minBetRun) {
      for (let i = betRun + 1; i <= minBetRun - 1; i++) {
        mergedBetRunPosition.push({ betRun: i, position: 0 });
      }
    }

    mergedBetRunPosition.forEach((item) => {
      if (betSlipObject.betType === "Yes") {
        if (item.betRun >= betRun) {
          item.position += profitAmount;
        } else {
          item.position += loseAmount;
        }
      } else if (betSlipObject.betType === "No") {
        if (item.betRun < betRun) {
          item.position += profitAmount;
        } else {
          item.position += loseAmount;
        }
      }
    });

    mergedBetRunPosition.sort((a, b) => a.betRun - b.betRun);

    const maxLossAmount = Math.min(
      ...mergedBetRunPosition.map((item) => item.position)
    );

    return maxLossAmount;
  };
  const [show, setShow] = useState("");
  const format = (number) => {
    var nf = new Intl.NumberFormat();
    return nf.format(number);
  };
  return (
    <div className="leagueBox">
      <div className="title" style={{ borderRadius: "0" }}>
        <Row>
          <Col style={{ fontWeight: "600" }} xs={8}>
            {title}
          </Col>
          <Col
            style={{ fontWeight: "600" }}
            xs={2}
            className="text-dark text-center"
          >
            {/* <Row>
              <Col className="text-center text-white px-0">{t("NO")}</Col>
              <Col className="text-center text-white px-0">{t("YES")}</Col>
            </Row> */}
          </Col>{" "}
          <Col
            xs={2}
            className="text-dark text-center"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            {" "}
            <span
              style={{
                paddingLeft: "5px",
                cursor: "pointer",
              }}
            >
              {active == undefined || active ? (
                <FaMinus
                  size={12}
                  color="white"
                  onClick={() =>
                    setActive((prev) => {
                      return {
                        ...prev,
                        ["fancy"]: !prev["fancy"],
                      };
                    })
                  }
                />
              ) : (
                <FaPlus
                  size={12}
                  color="white"
                  onClick={() =>
                    setActive((prev) => {
                      return {
                        ...prev,
                        ["fancy"]: !prev["fancy"],
                      };
                    })
                  }
                />
              )}
            </span>
          </Col>
        </Row>
      </div>
      {(active == undefined || active) && (
        <div
          style={{
            borderRadius: "0",
            background: "white",
            borderBottom: "1px solid #ddd",
          }}
        >
          <Row>
            <Col style={{ fontWeight: "600" }} xs={8}></Col>
            <Col
              style={{ fontWeight: "600" }}
              xs={2}
              className="text-dark text-center"
            >
              <Row>
                <Col className="text-center  px-0">{t("NO")}</Col>
                <Col className="text-center  px-0">{t("YES")}</Col>
              </Row>
            </Col>{" "}
            <Col xs={2}></Col>
          </Row>
        </div>
      )}
      {(active == undefined || active) &&
        data?.map((item, index) => {
          if (
            item?.odds?.ms == 4 ||
            item?.odds?.rt?.length == 0 ||
            item?.odds?.ms == 2 ||
            isEmpty(item?.odds?.rt)
          ) {
            return null;
          } else {
            let oldPosition = !isEmpty(
              position?.find((res) => {
                return res?.selectionId == item?.selectionId;
              })
            )
              ? position?.find((res) => {
                  return res?.selectionId == item?.selectionId;
                })?.position
              : "";

            let newPosition = "";
            if (oldPosition && position) {
              let oldPositionData =
                position?.find((res) => {
                  return res?.selectionId == item?.selectionId;
                }) || [];

              if (betSlipObject?.teamName === item?.name && showBetDialog) {
                betSlipObject.betType = betSlipObject?.object?.ib
                  ? "Yes"
                  : "No";

                newPosition =
                  oldPositionData && oldPositionData?.betRunPosition
                    ? mergeAndCalculate(betSlipObject, oldPositionData)
                    : 0;
              }
            } else {
              if (betSlipObject?.teamName === item?.name && showBetDialog) {
                if (betSlipObject?.object?.ib) {
                  if (Math.abs(item?.position) > 0) {
                    let backLoss =
                      Number(betSlipObject?.bidPrice) + Number(item?.position);
                    newPosition = backLoss;
                  } else {
                    let backLoss = Number(betSlipObject?.bidPrice);
                    newPosition = backLoss;
                  }
                } else {
                  if (Math.abs(item?.position) > 0) {
                    let backProfit =
                      (betSlipObject?.bidPrice * betSlipObject?.object?.pt) /
                      100;
                    newPosition = Number(backProfit) + Number(item.position);
                  } else {
                    let backProfit =
                      (betSlipObject?.bidPrice * betSlipObject?.object?.pt) /
                      100;
                    newPosition = backProfit;
                  }
                }
              }
            }

            let condition =
              betSlipObject?.teamName === item?.name &&
              Math.abs(newPosition) >= 0;
            return (
              <div
                style={{ borderBottom: "1px solid #ddd" }}
                className="laegueRow"
              >
                <Row>
                  <Col xs={8} className="d-flex justify-content-between">
                    <div
                      className="text-black selection-slip"
                      style={{
                        alignItems: "baseline",
                        flexDirection: "column",
                        paddingLeft: "10px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          // paddingLeft: "5px",
                          fontWeight: "600",
                        }}
                      >
                        {item?.name}{" "}
                      </span>
                      {(isNumber(oldPosition) || condition) && (
                        <span
                          style={{
                            // marginLeft: "10px",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "11px",
                          }}
                          className={` py-1 ${"team-red-score"}`}
                        >
                          {isNumber(oldPosition)
                            ? `(${Math?.abs(item?.position).toFixed(2)})`
                            : ""}
                          {betSlipObject?.teamName === item?.name &&
                            Math.abs(newPosition) >= 0 && (
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "5px",
                                  fontSize: "11px",
                                }}
                              >
                                <FaArrowRight
                                  color={
                                    item?.newPosition > 0 ? "green" : "red"
                                  }
                                  style={{ marginRight: "3px" }}
                                />{" "}
                                {`( ${Math.abs(newPosition).toFixed(2)} )`}
                              </span>
                            )}
                        </span>
                      )}{" "}
                    </div>

                    {isNumber(oldPosition) && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Button
                          style={{
                            marginRight: "10px",
                            fontSize: "13px",
                            padding: "5px 10px",
                            border: "none",
                            background: "rgb(255, 184, 12)",
                            color: "black",
                          }}
                          onClick={() =>
                            setShowPosition({
                              status: true,
                              object: { ...item, match: detail?.eventName },
                            })
                          }
                        >
                          Book
                        </Button>{" "}
                      </div>
                    )}
                  </Col>
                  <Col xs={2} className="text-dark text-center px-0">
                    <div
                      style={{
                        cursor: "pointer",
                        padding: "3px 0",
                        gap: "2px",
                      }}
                      className={`d-flex ${
                        item?.odds?.ms == 9 ||
                        item?.odds?.ms == 2 ||
                        item?.odds?.ms == 3 ||
                        item?.odds?.ms == 4
                          ? "disabled-new-div"
                          : ""
                      }  position-relative`}
                    >
                      <div
                        title={
                          item?.odds?.rt?.length > 0
                            ? item?.odds?.rt[0]?.rt
                            : ""
                        }
                        id={"lay_odds_fancy_" + index}
                        onClick={() =>
                          handelChange(
                            item?.odds?.rt[0],
                            "No",
                            item?.name,
                            item,
                            index
                          )
                        }
                        className={`redBoxs  d-inline-block ${
                          Number(
                            document.getElementById("lay_odds_fancy_" + index)
                              ?.title
                          ) !== item?.odds?.rt[0]?.rt
                            ? "spark-lay"
                            : ""
                        }  ${
                          betSlipObject?.teamName == item?.name &&
                          betSlipObject?.odds == item?.odds?.rt[0]?.rt &&
                          showBetDialog &&
                          betSlipObject?.betType == "No"
                            ? "lay-active"
                            : ""
                        }`}
                        // disabled-new-div
                        style={{ padding: "3px 0" }}
                      >
                        <div style={{ fontWeight: "800" }}>
                          {item?.odds?.rt[0]?.rt}{" "}
                        </div>
                        <span>{item?.odds?.rt[0]?.pt}</span>
                      </div>
                      <div
                        style={{ padding: "3px 0" }}
                        title={
                          item?.odds?.rt?.length > 0
                            ? item?.odds?.rt[1]?.rt
                            : ""
                        }
                        id={"back_odds_fancy_" + index}
                        onClick={() =>
                          handelChange(
                            item?.odds?.rt[1],
                            "Yes",
                            item?.name,
                            item,
                            index
                          )
                        }
                        className={`bluBoxs d-inline-block ${
                          Number(
                            document.getElementById("back_odds_fancy_" + index)
                              ?.title
                          ) !== item?.odds?.rt[1]?.rt
                            ? "spark-back"
                            : ""
                        }  ${
                          betSlipObject?.teamName == item?.name &&
                          betSlipObject?.odds == item?.odds?.rt[1]?.rt &&
                          showBetDialog &&
                          betSlipObject?.betType == "Yes"
                            ? "back-active "
                            : ""
                        }`}
                      >
                        {" "}
                        <div style={{ fontWeight: "800" }}>
                          {item?.odds?.rt[1]?.rt}
                        </div>
                        <span> {item?.odds?.rt[1]?.pt}</span>
                      </div>

                      {(item?.odds?.ms == 9 ||
                        item?.odds?.ms == 2 ||
                        item?.odds?.ms == 3 ||
                        item?.odds?.ms == 4) && (
                        <div
                          style={{ borderRadius: "3px", opacity: "0.6" }}
                          class="overlay-match "
                        >
                          {item?.odds?.ms == 9
                            ? "Ball Running"
                            : item?.odds?.ms == 2
                            ? "In Active"
                            : item?.odds?.ms == 3
                            ? t("Suspended")
                            : item?.odds?.ms == 4
                            ? "Closed"
                            : ""}
                        </div>
                      )}
                    </div>
                  </Col>{" "}
                  <Col
                    xs={2}
                    className="text-dark text-center px-0"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        width: "auto",
                        marginRight: "14px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          color: "black",
                          fontSize: "11px",
                          marginBottom: "2px",
                        }}
                      >
                        {t("Min")} :{" "}
                        <span style={{ fontWeight: "600", margin: "0 3px" }}>
                          {format(localLimit?.minAmount)}
                        </span>{" "}
                      </div>{" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          color: "black",
                          fontSize: "11px",
                        }}
                      >
                        {t("Max")} :{" "}
                        <span style={{ fontWeight: "600", margin: "0 3px" }}>
                          {format(localLimit?.maxAmount)}
                        </span>
                      </div>{" "}
                    </div>
                  </Col>
                </Row>
                {betSlipObject?.teamName == item?.fancyName &&
                  !isEmpty(betSlipObject?.betType) &&
                  betSlipObject?.playType == "fancy" &&
                  !profileData?.profile?.isOneClickBetStake && <RenderSlip />}
              </div>
            );
          }
        })}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <p
          className="mb-0"
          style={{
            fontSize: "14px",
            color: "black",
            fontWeight: "600",
            display: "flex",
            justifyContent: "center",
            padding: "2px",
          }}
        >
          {t("Min")} : {localLimit?.minAmount} | {t("Max")} :{" "}
          {localLimit?.maxAmount}
        </p>
      </Modal>
      {showPosition?.status && !isEmpty(showPosition?.object) && (
        <BookPosition
          showPosition={showPosition}
          setShowPosition={setShowPosition}
        />
      )}
    </div>
  );
};

export default Fancy;
